export default __webpack_public_path__ + "b8af3bfbacf78fa9f57c84cb958bf789.png";